import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function ChangePassword() {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (p1.length < 6) { toast.error("A senha deve ter ao menos 6 caracteres."); return; }
    if (p1 !== p2) { toast.error("As senhas não coincidem."); return; }
    setLoading(true);
    try {
      await changePassword(p1);
      toast.success("Senha alterada com sucesso.");
      navigate(user?.role === "admin" ? "/painel" : "/conta", { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-ink border border-white/15 px-4 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-cobalt transition-colors duration-300";

  return (
    <div className="min-h-screen grain flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <img src="/logo-full.png" alt="JeaxLabs" className="h-9 w-auto mb-8" />
        <div className="flex items-center gap-2 text-acid mb-3">
          <ShieldCheck className="w-4 h-4" />
          <span className="font-mono text-xs uppercase tracking-[0.3em]">Primeiro acesso</span>
        </div>
        <h1 className="font-head font-black text-3xl md:text-4xl tracking-tight mb-3">Crie uma nova senha</h1>
        <p className="text-white/50 mb-8">Por segurança, defina a sua própria senha antes de continuar.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <input data-testid="new-password" type="password" className={field} placeholder="Nova senha" value={p1} onChange={(e) => setP1(e.target.value)} />
          <input data-testid="confirm-password" type="password" className={field} placeholder="Confirmar nova senha" value={p2} onChange={(e) => setP2(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="change-password-submit"
                  className="w-full inline-flex items-center justify-center gap-3 bg-cobalt text-white px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-white hover:text-ink transition-colors duration-300 disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar e continuar"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
